module.exports = __webpack_public_path__ + "static/img/shop_front_3.01a403e7.jpg";